<div class="content-info">
  <div class="content-title">
    <h3 class="title">Goods Receipt Notes</h3>
    <div class="title-actions">
      <label class="zf-search" title="Search by GRN number">
        <i class="bi bi-search"></i>
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search GRN number" />
      </label>
      <button class="btn btnprimary text-nowrap" [routerLink]="['/grn/create-grn']">
        <i class="bi bi-plus-lg"></i>Create GRN
      </button>
    </div>
  </div>

  <!-- List filters: vendor / received-date range / status (server-side) -->
  <div class="zf-toolbar d-print-none pt-2">
    <div class="zf-toolbar-field" style="min-width: 240px">
      <label>Vendor</label>
      <app-search-select [items]="vendors" bindLabel="name" bindValue="id" entity="vendor"
        [(ngModel)]="filters.vendorId" placeholder="All vendors" (change)="onFilterChange()"
        (clear)="onFilterChange()"></app-search-select>
    </div>
    <div class="zf-toolbar-field">
      <label>Received from</label>
      <input type="date" class="form-control" [(ngModel)]="filters.fromDate" [max]="filters.toDate || null"
        (change)="onFilterChange()" />
    </div>
    <div class="zf-toolbar-field">
      <label>Received to</label>
      <input type="date" class="form-control" [(ngModel)]="filters.toDate" [min]="filters.fromDate || null"
        (change)="onFilterChange()" />
    </div>
    <div class="zf-toolbar-field" style="min-width: 130px">
      <label>Status</label>
      <select class="form-select" [(ngModel)]="filters.status" (change)="onFilterChange()">
        <option value="">All</option>
        @for (s of statusOptions; track s) {
        <option [value]="s">{{ s }}</option>
        }
      </select>
    </div>
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearFilters()"
      [disabled]="!hasActiveFilters()">
      <i class="bi bi-x-circle"></i>Clear
    </button>
  </div>

  <div class="common-table">
    <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
      <table class="table">
        <thead>
          <tr>
            <th>GRN Number</th>
            <th>PO Number</th>
            <th>Vendor</th>
            <th>Received Date</th>
            <th class="zf-num">Total Items</th>
            <th class="zf-num">Total Units</th>
            <th class="zf-num">Amount (INR)</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @if(grnsLoading) {
          <tr>
            <td colspan="9" class="text-center">Loading GRNs…</td>
          </tr>
          } @else { @if(!grnList.length) {
          <tr>
            <td colspan="9">
              <div class="zf-empty">
                <strong>No goods receipt notes match this view</strong>
                <span>Clear the filters or receive goods against a purchase order.</span>
              </div>
            </td>
          </tr>
          } @else { @for(grn of grnList; track grn.id) {
          <tr>
            <td class="zf-key">
              <a [routerLink]="['/grn/edit', grn.id]" [queryParams]="{ view: true }">{{ grn.grnNumber }}</a>
            </td>
            <td class="zf-mono zf-dim">{{ grn?.poNumber }}</td>
            <!-- list endpoint returns a flat vendorName; the search endpoint
                 returns the joined vendor object -->
            <td>{{ grn?.vendorName || grn?.vendor?.name || '-' }}</td>
            <td class="zf-mono">{{ grn.receivedDate | date : "dd-MM-yy" }}</td>
            <td class="zf-num">{{ grn.purchaseOrder?.totalItems || grn.totalItems || 0 }}</td>
            <td class="zf-num zf-dim">{{ grn.purchaseOrder?.totalUnits || grn.totalQty || 0 }}</td>
            <td class="zf-num zf-strong">{{ grn.totalAmount || 0 | number : '1.2-2' }}</td>
            <td>
              <span class="zf-status" [ngClass]="{
                  danger: grn.status === 'CANCELLED',
                  ok: grn.status === 'POSTED',
                  warn: grn.status !== 'CANCELLED' && grn.status !== 'POSTED'
                }">{{ grn.status }}</span>
              <!-- Amended after posting: the list has to show it, or the only
                   way to notice is to open the document. -->
              @if (grn.revisionNo > 0) {
              <span class="zf-status warn ms-1" title="Amended after posting — open the GRN to see the history">
                Rev {{ grn.revisionNo }}
              </span>
              }
            </td>
            <td>
              <div class="dropdown d-flex justify-content-center" style="position: static">
                <button class="btn zf-row-menu dropdown-toggle" type="button" id="dropdownMenuButton-{{ grn.id }}"
                  data-bs-toggle="dropdown" aria-expanded="false" title="Actions">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end" [attr.aria-labelledby]="'dropdownMenuButton-' + grn.id"
                  style="position: absolute; z-index: 1050">
                  <li>
                    <a class="dropdown-item" [routerLink]="['/grn/edit', grn.id]" [queryParams]="{ view: true }">
                      <i class="bi bi-eye"></i> View details
                    </a>
                  </li>
                  <!-- Posted GRNs are editable only when Configuration >
                       "Allow editing posted GRNs" is on; the save is gated
                       server-side too. -->
                  @if (grn.status === 'DRAFT' || (grn.status === 'POSTED' && allowEditPosted)) {
                  <li>
                    <a class="dropdown-item" [routerLink]="['/grn/edit', grn.id]">
                      <i class="bi bi-pencil-square"></i> Edit
                    </a>
                  </li>
                  }
                  @if (grn.status === 'POSTED') {
                  <li>
                    <a class="dropdown-item" [routerLink]="['/transfer-out/create']" [queryParams]="{ fromGrn: grn.id }">
                      <i class="bi bi-truck"></i> Create transfer out
                    </a>
                  </li>
                  }
                  <li>
                    <a class="dropdown-item" (click)="downloadGrn(grn.id)">
                      <i class="bi bi-file-earmark-pdf"></i> Download GRN
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" (click)="downloadVendorReceipt(grn.id)">
                      <i class="bi bi-receipt"></i> Vendor receipt
                    </a>
                  </li>
                  <!-- Cancel reverses the whole receipt out of stock. Shown
                       only when Configuration > "Allow cancelling posted GRNs"
                       is on AND the user is an Admin; the server checks both
                       again, and refuses if the stock has already moved on. -->
                  @if (grn.status === 'POSTED' && allowCancelPosted) {
                  <li><hr class="dropdown-divider"></li>
                  <li>
                    <a class="dropdown-item text-danger" (click)="openCancelDialog(grn)">
                      <i class="bi bi-x-octagon text-danger"></i> Cancel GRN
                    </a>
                  </li>
                  }
                </ul>
              </div>
            </td>
          </tr>
          } } }
        </tbody>
      </table>
    </div>

    <div class="table-pagination">
      <div class="pagination-count">
        <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
        <span>entries per page</span>
      </div>
      <ul class="pagination">
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <a class="page-link" aria-label="Previous">&lsaquo;</a>
        </li>
        <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
          <a class="page-link">1</a>
        </li>
        @if (currentPage > 4) {
        <li class="page-item disabled"><a class="page-link">…</a></li>
        }
        @for (page of getVisiblePages(); track page) {
        <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
          <a class="page-link">{{ page }}</a>
        </li>
        }
        @if (currentPage < pageCount - 3) {
        <li class="page-item disabled"><a class="page-link">…</a></li>
        }
        @if (pageCount > 1) {
        <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
          <a class="page-link">{{ pageCount }}</a>
        </li>
        }
        <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
          <a class="page-link" aria-label="Next">&rsaquo;</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- ── Cancel a posted GRN ───────────────────────────────────────────────
     Reversing a receipt moves real stock, so the dialog states plainly what
     will happen and makes the reason mandatory — the same reason the
     amendment trail records. -->
@if (cancelTarget) {
<div class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(18, 20, 26, 0.5)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-danger">
          <i class="bi bi-x-octagon me-1"></i>
          Cancel GRN <span class="zf-mono">{{ cancelTarget.grnNumber }}</span>
        </h5>
        <button type="button" class="btn-close" [disabled]="cancelling" (click)="closeCancelDialog()"></button>
      </div>
      <div class="modal-body">
        <p class="mb-3">
          The full receipt — received and free quantities — will be taken back out of stock and this GRN will be marked
          <strong>CANCELLED</strong>. This cannot be undone. If the goods have already been sold or moved on, the
          cancellation is refused.
        </p>

        <div class="mb-3">
          <label class="form-label">Reason <span class="text-danger">*</span></label>
          <select class="form-select" [(ngModel)]="cancelReasonId" [class.is-invalid]="cancelSubmitted && !cancelReasonId"
            [disabled]="cancelling">
            <option [ngValue]="null">Select a reason</option>
            @for (reason of cancelReasons; track reason.id) {
            <option [ngValue]="reason.id">{{ reason.shortReason || reason.description || reason.code }}</option>
            }
          </select>
          @if (!cancelReasons.length) {
          <div class="form-text text-danger">
            No GRN reasons configured. Add one under Administration &gt; Reason Master before cancelling.
          </div>
          }
        </div>

        <div class="mb-1">
          <label class="form-label">Note (optional)</label>
          <textarea class="form-control" rows="2" maxlength="500" [(ngModel)]="cancelNote" [disabled]="cancelling"
            placeholder="What happened, in your own words"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnsecondary" [disabled]="cancelling" (click)="closeCancelDialog()">Keep GRN</button>
        <button type="button" class="btn btn-danger" [disabled]="cancelling || !cancelReasonId" (click)="confirmCancel()">
          @if (cancelling) {
          <span class="spinner-border spinner-border-sm me-1"></span>
          }
          Cancel GRN
        </button>
      </div>
    </div>
  </div>
</div>
}
